import api from "../lib/axios";

const authHeaders = (token) =>
  token ? { Authorization: `Bearer ${token}` } : {};

/**
 * Floor Plan Service
 */

/**
 * Get list of floor plans for an event
 * @param {number} eventId 
 * @param {number} userId 
 * @param {string} token 
 */
export const getFloorPlans = async (eventId, token) => {
  return api.get(`/floor-plan/list`, {
    params: { event_id: eventId },
    headers: authHeaders(token)
  });
};

/**
 * Create a new floor plan
 * @param {object} data 
 * @param {string} token 
 */
export const createFloorPlan = async (data, token) => {
  return api.post(`/floor-plan/create`, data, {
    headers: authHeaders(token)
  });
};

/**
 * Update an existing floor plan
 * @param {number} id 
 * @param {object} data 
 * @param {string} token 
 */
export const updateFloorPlan = async (id, data, token) => {
  return api.put(`/floor-plan/update/${id}`, data, {
    headers: authHeaders(token)
  });
};

/**
 * Delete a floor plan
 * @param {number} id 
 * @param {number} userId 
 * @param {string} token 
 */
export const deleteFloorPlan = async (id, eventId, token) => {
  return api.delete(`/floor-plan/delete/${id}`, {
    data: { event_id: eventId },
    headers: authHeaders(token)
  });
};

/**
 * Get public floor map
 * @param {number} eventId 
 */
export const getPublicFloorMap = async (eventId) => {
  return api.get(`/floor-plan/public/floor-map/${eventId}`);
};
/**
 * Get focus area for a floor plan
 * @param {number} floorPlanId
 * @param {string} token
 */
export const getFocusArea = async (floorPlanId, eventId, token) => {
  return api.get(`/floor-plan/focus-area/list`, {
    params: { floor_plan_id: floorPlanId, event_id: eventId },
    headers: authHeaders(token)
  });
};

/**
 * Save focus area for a floor plan
 * @param {object} data
 * @param {string} token
 */
export const saveFocusArea = async (data, token) => {
  return api.post(`/floor-plan/focus-area/save`, data, {
    headers: authHeaders(token)
  });
};

/**
 * Delete focus area for a floor plan
 * @param {number} floorPlanId
 * @param {string} token
 */
export const deleteFocusArea = async (floorPlanId, token) => {
  return api.delete(`/floor-plan/focus-area/${floorPlanId}`, {
    headers: authHeaders(token)
  });
};

/**
 * Bulk delete all floor plans for an event
 * @param {number} eventId 
 * @param {string} token 
 */
export const bulkDeleteFloorPlans = async (eventId, token) => {
  return api.delete(`/floor-plan/bulk-delete/${eventId}`, {
    headers: authHeaders(token)
  });
};

/**
 * Upload an image for floor plans
 * @param {FormData} formData 
 * @param {string} token 
 */
export const uploadFloorPlanImage = async (formData, token) => {
  return api.post(`/floor-plan/images/upload`, formData, {
    headers: {
      ...authHeaders(token),
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 * Get list of images for floor plans
 * @param {number} eventId 
 * @param {object} filters 
 * @param {string} token 
 */
export const getFloorPlanImages = async (eventId, filters, token) => {
  return api.get(`/floor-plan/images/list`, {
    params: { event_id: eventId, ...filters },
    headers: authHeaders(token)
  });
};

/**
 * Delete a floor plan image
 * @param {number} id 
 * @param {string} token 
 */
export const deleteFloorPlanImage = async (id, token) => {
  return api.delete(`/floor-plan/images/delete/${id}`, {
    headers: authHeaders(token)
  });
};
